import { Container, useTheme } from '@mui/material';
import { createLoginLayoutStyles } from './LoginLayoutStyles';
import { AppTheme } from '../theme';

function LoginLayout(props: any) {
    const theme: AppTheme = useTheme();
    const styles = createLoginLayoutStyles(theme);
    return (
        <Container maxWidth={false} disableGutters={true} sx={[styles.container]}>
            {props.children}
        </Container>
    );
}

export default LoginLayout;
